module.exports = __webpack_public_path__ + "static/img/2_1.008862eb.png";